require('./hireCardViaTStep2.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { HireCreditLimit } = require('components/hire/hireCreditLimit/hireCreditLimit');
const { HirePaymentMethod } = require('components/hire/hirePaymentMethod/hirePaymentMethod');
import { DisclaimerPersonalInfo } from 'components/hire/cardViaT/disclaimerPersonalInfo/disclaimerPersonalInfo';

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');
// @ constants
const {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CHECKING_ACCOUNT_CODE,
    CREDIT_CARD_STANDARD_VIA_T,
    CREDIT_CARD_SUBTYPE_VIA_T,
    CREDIT_CARD_TYPE_VIA_T,
    EURO_TEXT,
    SECOND_STEP,
    WIZARD_SECOND_STEP
} = require('constants/index');

const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');

class hireCardViaTStep2 extends React.Component {

    constructor(props) {
        super(props);
        this.onCreditLimitModalContinue = this.onCreditLimitModalContinue.bind(this);
    }

    componentDidMount() {
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.filterAccounts(), immAccounts.get('byId'));
        if(allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    onCreditLimitModalContinue() {
        const {
            immHireCreditLimit,
            setHireCreditLimit,
            toggleCreditLimitModal,
            validate,
        } = this.props;

        setHireCreditLimit(immHireCreditLimit.get('creditLimitModalValue'), true);
        toggleCreditLimitModal(false);
        validate(WIZARD_SECOND_STEP, true);
    }

    filterAccounts() {
        const { immAccounts } = this.props;
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
            ACCOUNT_INTERVENTION_REPRESENTATIVE
        ];
        const accountsIndexes = immAccounts.get('byOrder').filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    render() {
        const {
            handleAccountChange,
            immAccounts,
            immGlobalVariables,
            immHireCardViaT,
            immHireCreditLimit,
            immHirePaymentMethod,
            isInactiveAccountsEnabled,
            newCardsFF
        } = this.props;
        const immStep2 = immHireCardViaT.getIn(['steps', SECOND_STEP]);
        const accountErrorMsgVisible = immStep2.get('accountIsDirty') && !immStep2.get('accountIsValid');
        const accountErrorMsg = formatText('hireCardViaT-step2SelectAccountError');
        const accountLabel = formatText('hireCardViaT-step2SelectAccount');
        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-viaTLinkUrl');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        return (
            <article className="hire-card-via-t-step-two">
                <FormattedText
                    className="hire-card-via-t__step-title"
                    value="hireCardViaT-step2Title"
                />
                <DropdownAccounts
                    accountsIndexes={this.filterAccounts()}
                    currentAccountId={immStep2.get('accountId')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    onAccountChange={handleAccountChange}
                    optionalElement={DisclaimerPersonalInfo()}
                    showAvailableBalance
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    loading={isBlockedAccountsLoading}
                />
                <h4 className="hire-card-via-t__section-header">
                    <FormattedText value="hireCardViaT-step2CardData" />
                </h4>
                <HireCreditLimit
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    productSubType={CREDIT_CARD_SUBTYPE_VIA_T}
                    productType={CREDIT_CARD_TYPE_VIA_T}
                    referenceStandard={CREDIT_CARD_STANDARD_VIA_T}
                    defaultLimit={300}
                    handleModalContinue={this.onCreditLimitModalContinue}
                    newSetCardLimit={newCardsFF ? true : false}
                />
                <HirePaymentMethod
                    immCreditLimit={immHireCreditLimit}
                    immGlobalVariables={immGlobalVariables}
                    immHirePaymentMethod={immHirePaymentMethod}
                    creditType="viat"
                    newSetCardLimit={newCardsFF ? true : false}
                />
                <div className="hire-card-via-t-step-two__disclaimer-personal-info">
                    <OKMessage type="informative">
                        <FormattedText value="disclaimerPersonalInfo-viaTMsg" />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value="disclaimerPersonalInfo-viaTLinkText" />
                        </OKLink>
                    </OKMessage>
                </div>
            </article>
        );
    }
}

hireCardViaTStep2.propTypes = {
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardViaT: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
};

module.exports = hireCardViaTStep2;
